import * as React from 'react'
import { useState, useEffect, useRef } from 'react'
import Box from '@mui/material/Box'
import Card from '@mui/material/Card'
import '../../../src/Styles/TableComponent.css'
import Chip from '@mui/material/Chip'
import { Typography, Badge, Popover, Pagination, Menu, MenuItem, Tooltip, Popper, Grow } from '@mui/material'
import { Checkbox } from 'src/Common/ui/checkbox'
import * as RoutePath from '../../Entities/RoutePath'
import { BsThreeDotsVertical } from 'react-icons/bs'
import { LuUndo2 } from 'react-icons/lu'
import { RiChatHistoryLine } from 'react-icons/ri'
import { GrcTableContainer, GrcTableHead, GrcTableBody, GrcTableHeadRow, GrcTableRow, GrcTableCell, GrcTable } from 'src/Common/ui/TableComponent'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router'
import { cn, getDayBasedAging, getDayBasedAgingInClosedBucket } from 'src/lib/utils'
import { CHIP_CONTROLLED, CHIP_EXTREME, CHIP_HIGH, CHIP_LOW, CHIP_MEDIUM, FILTER_RESET, FILTER_SHOW_HIDE, RISK_DISABLED_COLUMN_SETTINGS, RISK_RATINNG } from 'src/Entities/RiskTypes'
import _, { } from 'lodash'

import { RiskHistoryFilterContainer } from '../Risk/RiskHistory/RiskHistoryFilterContainer'
import CustomSearchField from 'src/Common/ui/searchInput'
import { VerticalTimelineContainer } from '../Governance/VerticalTimeline/VerticalTimelineContainer'
import PopoverMui from 'src/Common/ui/PopoverMui'
import BellAnimation from 'src/Common/Icon/BellAnimation'
import useCustomNavigate from 'src/Common/ui/Navigate'
import { Button } from 'src/Common/ui/button'
import ContentCircle from 'src/Common/ui/contentCircle'
import { CHIP_VERY_HIGH, CHIP_VERY_LOW, ISSUE_TAB } from 'src/Entities/IssueTypes'
import { useSettingsStore } from '../SettingsContainer/Store/Store'
import { useIssueStore } from './store/IssueStore'
import { getIssueHistory } from 'src/API/IssueApi'

const IssueTable = ({ tabletext = 'No Records Found', selectedMenu, riskType, tableHeaders, tableBodyData, riskDetails, onTabChange, activeTab, generalCount, nonComplianceCount, dashboardView, title }) => {
    const getIssueHistoryData = useIssueStore((state) => state.getIssueHistoryData)
    const [ searchValue, setSearchValue ] = useState('')
    const [ isModalOpen, setIsModalOpen ] = useState(null)
    const [ anchorEl, setAnchorEl ] = useState(null)
    const [ anchorPopper, setAnchorPopper ] = useState(null)
    const [ Heatmap, setHeatmap ] = useState('')
    const { configurationData, getConfigurationBasedOrganization } = useSettingsStore()
    useEffect(() => {
        getConfigurationBasedOrganization(orgId)
    }, [])
    useEffect(() => {
        if (configurationData.length > 0) {
            const data = configurationData?.filter(element => element?.kindId === 5)
            const heatmap = data?.find(element => element.values === 1)?.subtitleName
            setHeatmap(heatmap?.split(' ')[0])
        }
    }, [configurationData])

    const [ selectedHeaders, setSelectedHeaders ] = useState(riskType !== 3 ? tableHeaders?.filter((dt) => dt?.field !== 'type')?.map((header) => ({ ...header, checked: ![ 'raisedDepartment', 'raisedBy', 'createdDate' ].includes(header.field) })) : tableHeaders?.map((header) => ({ ...header, checked: ![ 'raisedDepartment', 'raisedBy', 'createdDate' ].includes(header.field) })))
    useEffect(() => {
        setSelectedHeaders(
            riskType !== 3
                ? tableHeaders?.filter((dt) => dt?.field !== 'type')?.map((header) => ({ ...header, checked: ![ 'raisedDepartment', 'raisedBy', 'createdDate' ].includes(header.field) }))
                : tableHeaders?.map((header) => ({ ...header, checked: ![ 'raisedDepartment', 'raisedBy', 'createdDate' ].includes(header.field) }))
        )
    }, [ riskType, tableHeaders ])

    const [ clicked, setClicked ] = useState({
        Extreme: false,
        'Very High': false,
        High: false,
        Medium: false,
        Low: false,
        'Very Low': false,
        Controlled: false
    })
    const customNavigate = useCustomNavigate()
    const navigate = useNavigate()
    const [ popperData, setPopperData ] = useState([])
    // const [ page, setPage ] = useState(1)
    const [ searchColumnValue, setSearchColumnValue ] = useState('')
    // const [ sortField, setSortField ] = useState(null)
    // const [ sortDirection, setSortDirection ] = useState('asc')
    const [ sortToggle, setSortToggle ] = useState(false)
    const [ filteredRegulationData, setfilteredRegulationData ] = useState([])
    const [ paginatedData, setPaginatedData ] = useState([])
    const [ currentPage, setCurrentPage ] = useState(1)
    const rowsPerPage = 5
    const [ totalPages, setTotalPages ] = useState(Math.ceil(tableBodyData?.length / rowsPerPage))
    const [ funnelDatas, setFunnelDatas ] = useState([])
    const [ funnelSearch, setFunnelSearch ] = useState('')
    const ref = useRef()
    const toggleDrawer = () => {
        ref.current.toggleDraw()
    }
    // console.log('test', paginatedData.map(risk => {
    //   if (typeofrisk === 3) {
    //     const { riskType, ...rest } = risk; // Remove riskType key
    //     return rest;
    //   }
    //   return risk; // Keep other objects unchanged
    // }));
    const timelineRef = useRef()
    const toggleTimelineDrawer = () => {
        timelineRef.current.toggleDraw()
    }

    useEffect(() => {
        setfilteredRegulationData(tableBodyData)
        tableHeaders.forEach(header => {
            if (header.field.length > 0) {
                const columnHead = tableBodyData?.map(item => Array.isArray(item[header.field]) ? item[header.field] : item[header.field === 'risk' ? 'title' : header.field])
                const arr = columnHead?.flat(Infinity)
                const uniqueData = _.uniq(arr)
                setFunnelDatas(prevstate => {
                    return {
                        ...prevstate,
                        [header.field]: [ ...uniqueData.map((item, i) => {
                            return {
                                label: item,
                                checked: true,
                                show: true
                            }
                        }), { label: FILTER_SHOW_HIDE, checked: true, show: true }]
                    }
                })
            }
        })
        setPaginatedData(tableBodyData?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
    }, [tableBodyData])

    useEffect(() => {
        setEntries({
            entry: filteredRegulationData?.length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + paginatedData?.length - 1 + 1
        })
    }, [paginatedData])

    useEffect(() => {
        setPaginatedData(filteredRegulationData?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
        setTotalPages(Math.ceil(filteredRegulationData?.length / rowsPerPage))
        chipCountController()
    }, [filteredRegulationData])
    const handleMouseEnter = (event, hoverData) => {
        setAnchorPopper(event.currentTarget)
        setPopperData(hoverData)
    }

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen)
    }

    const openModal = (event, id) => {
        setRiskId(id)
        setIsModalOpen(event?.currentTarget)
    }

    const handleMouseLeave = () => {
        setAnchorPopper(null)
        setPopperData([])
    }

    const handleSearchChange = (event) => {
        const searchTerm = event.toLowerCase()
        setSearchValue(searchTerm)

        const activeFilters = Object.keys(clicked).filter(chip => clicked[chip])

        const filtered = tableBodyData?.filter((row) => {
            const matchesSearch = Object.values(row).some((value) =>
                value?.toString().toLowerCase().includes(searchTerm)
            )
            const matchesChips = activeFilters.length === 0 || activeFilters.includes(row?.riskScore)

            return matchesSearch && matchesChips
        })

        setfilteredRegulationData(filtered)
    }

    const handleSearchColumnChange = (event) => {
        const searchTerm = event.toLowerCase()
        setSearchColumnValue(searchTerm)
    }

    const handleRowClick = (params) => {
        if (location.pathname === RoutePath.MAIN_CONTAINER.MAIN + RoutePath.HISTORY.URI) {
            navigate(`/GRC/history/${params?.referenceId}`, { state: { riskDetails: { title: params?.title, issueId: params?.issueId, status: params?.status, level: params?.riskScore, createdAt: params?.createdDate } } })
        } else if (location.pathname === '/GRC/issue-history') {
            navigate(`/GRC/issue-register/${ISSUE_TAB.ANALYZE_AND_PLAN}/${params?.referenceId}`, { state: { issueDetails: { title: params?.title, issueId: params?.issueId, status: params?.status, level: params?.issueScore, createdAt: params?.createdDate } } })
        } else {
            navigate(`${params?.referenceId}`, { state: { issueDetails: { title: params?.title, issueId: params?.issueId, status: params?.status, level: params?.issueScore, createdAt: params?.createdDate } } })
        }
    }

    const handleAddRisk = () => {
        customNavigate(RoutePath.MAIN_CONTAINER.MAIN + RoutePath.ISSUE.URI + RoutePath.ISSUE.ADD_ISSUE, 'Add Issue')
    }
    useEffect(() => {
        setPaginatedData(filteredRegulationData?.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
    }, [currentPage])
    const handlePageChange = (event, newPage) => {
        // setPage(newPage)
        setCurrentPage(newPage)
    }
    const [ chipData, setChipData ] = useState([{ label: CHIP_VERY_HIGH, color: '--Extreme', count: 0 }, { label: CHIP_HIGH, color: '--High', count: 0 }, { label: CHIP_MEDIUM, color: '--Medium', count: 0 }, { label: CHIP_LOW, color: '--Low', count: 0 }, { label: CHIP_VERY_LOW, color: '--Controlled', count: 0 }])

    const handleColumnButtonClick = (event) => {
        setAnchorEl(anchorEl ? null : event.currentTarget)
    }

    const getColor = (score) => {
        const rating = RISK_RATINNG.find((r) => r.title === score)
        return rating ? rating.color : 'hsl(var(--grey))' // Default color if not found
    }

    const getPeriodicity = periodicity => {
        return (
            <div className="flex align-center items-center space-x-1">
                {periodicity?.map((entry, index) => (
                    <Tooltip
                        key={index}
                        title={
                            <div className="p-2 text-sm">
                                <p className="font-semibold">{entry.score}</p>
                                <p>{new Date(entry.date).toLocaleDateString('en-US', {
                                    month: 'short',
                                    day: '2-digit',
                                    year: 'numeric'
                                })}</p>
                            </div>
                        }
                        arrow
                    >
                        <div
                            className="w-4 h-6 rounded-full transition-transform transform hover:scale-110"
                            style={{ width: '0.7rem', height: '2rem', backgroundColor: getColor(entry.score) }}
                        />
                    </Tooltip>
                ))}
            </div>
        )
    }

    const handleToggleColumn = (header) => {
        setSelectedHeaders((prevHeaders) =>

            prevHeaders.map((h) => {
                if (h.field === header.field) {
                    return { ...h, checked: !h.checked }
                }
                return h
            })
        )
    }
    const [ selectAll, setSelectAll ] = useState(false)
    const handleSelectAll = (event) => {
        setSelectedHeaders((prevHeaders) =>
            prevHeaders.filter((h) => h.field !== '').map((h) => ({ ...h, checked: RISK_DISABLED_COLUMN_SETTINGS.find(el => el === h.headerName) ? h.checked : event }))
        )
        setSelectAll(event)
    }

    const handleReset = () => {
        setSelectedHeaders((prevHeaders) =>
            prevHeaders.filter((h) => h.field !== '').map((h) => ({ ...h, checked: true }))
        )
        setSelectAll(true)
    }

    const chipColorStyle = riskScoreValue => {
        let textColor = 'hsl(var(--foreground))'
        if (riskScoreValue === CHIP_CONTROLLED || riskScoreValue === CHIP_VERY_LOW) {
            textColor = 'hsl(var(--Controlled))'
        } else if (riskScoreValue === CHIP_LOW) {
            textColor = 'hsl(var(--Low))'
        } else if (riskScoreValue === CHIP_MEDIUM) {
            textColor = 'hsl(var(--Medium))'
        } else if (riskScoreValue === CHIP_HIGH) {
            textColor = 'hsl(var(--High))'
        } else if (riskScoreValue === CHIP_EXTREME || riskScoreValue === CHIP_VERY_HIGH) {
            textColor = 'hsl(var(--Extreme))'
        }
        return textColor
    }

    // const handleRowSelect = (rowId) => {
    //     setSelectedRows(prevSelectedRows => {
    //         const updatedRows = prevSelectedRows.filter((id, index) => index !== 0 && index !== prevSelectedRows.length - 1)

    //         if (updatedRows.includes(rowId)) {
    //             return updatedRows.filter(id => id !== rowId)
    //         } else {
    //             return [ ...updatedRows, rowId ]
    //         }
    //     })
    // }

    // const handleSort = (field) => {
    //     const isAsc = sortField === field && sortDirection === 'asc'
    //     setSortDirection(isAsc ? 'desc' : 'asc')
    //     setSortField(field)

    //     const sortedData = [...filteredRegulationData].sort((a, b) => {
    //         if (a[field] < b[field]) return isAsc ? -1 : 1
    //         if (a[field] > b[field]) return isAsc ? 1 : -1
    //         return 0
    //     })
    //     setfilteredRegulationData(sortedData)
    // }

    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    const [ showTypeFilter, setShowTypeFilter ] = useState(null)
    const [ funnelType, setFunnelType ] = useState('')

    const sortFilter = (findOf) => {
        // eslint-disable-next-line no-constant-condition
        findOf = findOf === 'risk' ? 'title' : 'aging' ? 'createdDate' : findOf

        const sorted = [...filteredRegulationData].sort((a, b) => {
            if (typeof a[findOf] === 'string') {
                return sortToggle
                    ? b[findOf].toLowerCase().localeCompare(a[findOf].toLowerCase())
                    : a[findOf].toLowerCase().localeCompare(b[findOf].toLowerCase())
            } else {
                return sortToggle ? b[findOf] - a[findOf] : a[findOf] - b[findOf]
            }
        })

        setSortToggle(!sortToggle)
        setfilteredRegulationData(sorted)
    }

    const handleTypeClick = (event, field) => {
        setShowTypeFilter(event.target)
        setFunnelType(field)
        setCurrentPage(1)
    }
    useEffect(() => {
        if (tableBodyData?.length > 0) {
            const chipData = chipController(tableBodyData, clicked)
            const tempDatas = funnelcontroller(chipData)
            setfilteredRegulationData(tempDatas)
        }
    }, [funnelDatas])
    const chipCountController = () => {
        const count = {
            Extreme: 0,
            'Very High': 0,
            High: 0,
            Medium: 0,
            Low: 0,
            'Very Low': 0,
            Controlled: 0
        }
        tableBodyData?.forEach((ele) => {
            if (ele.issueScore === CHIP_HIGH) {
                count.High++
            } else if (ele.issueScore === CHIP_VERY_HIGH) {
                count['Very High']++
            } else if (ele.issueScore === CHIP_MEDIUM) {
                count.Medium++
            } else if (ele.issueScore === CHIP_LOW) {
                count.Low++
            } else {
                count['Very Low']++
            }
        })
        setChipData((prevState) => (
            prevState.map(ele => {
                return {
                    ...ele,
                    count: count[ele.label]
                }
            })
        ))
    }
    const funnelcontroller = (paramData) => {
        let tempDatas = paramData
        Object.keys(funnelDatas).forEach(key => {
            // eslint-disable-next-line array-callback-return
            tempDatas = tempDatas.filter(data => {
                const tempKey = key
                if (funnelDatas[key]?.some(item => item.checked && (Array.isArray(data[tempKey]) ? data[tempKey].includes(item.label) : item.label === data[tempKey]))) {
                    return data
                }
            })
        })
        return tempDatas
    }
    const chipController = (data, chipArray) => {
        const activeFilters = Object.keys(chipArray).filter(chip => chipArray[chip])
        let filtered = data.filter((row) => {
            return Object.values(row).some((value) =>
                value?.toString().toLowerCase().includes(searchValue.toLowerCase())
            )
        })

        if (activeFilters.length > 0) {
            filtered = filtered.filter(row =>
                activeFilters.includes(row?.issueScore)
            )
        }
        return filtered
    }
    const handleTypeFilter = (value) => {
        setFunnelDatas((prevState) => {
            return {
                ...prevState,
                [funnelType]: prevState[funnelType].map((item) => {
                    if (value === FILTER_RESET) {
                        return { ...item, checked: true }
                    }
                    if (value === FILTER_SHOW_HIDE) {
                        return { ...item, checked: !item.checked }
                    } else {
                        if (item.label === value) {
                            return { ...item, checked: !item.checked }
                        }
                        return item
                    }
                })
            }
        })
        setCurrentPage(1)
    }

    const handleChipClick = (chipLabel) => {
        const newClickedState = {
            ...clicked,
            [chipLabel]: !clicked[chipLabel]
        }
        setClicked(newClickedState)
        const filtered = chipController(tableBodyData, newClickedState)
        const funnel = funnelcontroller(filtered)
        setfilteredRegulationData(funnel)
    }

    const handleFunnelSearch = (e) => {
        setFunnelSearch(e)
        funnelSearchController(e)
    }

    const funnelSearchController = (searchTerm) => {
        setFunnelDatas((prevState) => {
            return {
                ...prevState,
                [funnelType]: prevState[funnelType]?.map((item) => {
                    if (searchTerm?.length === 0) {
                        return { ...item, show: true }
                    }
                    if (item.label.toLowerCase().includes(searchTerm.toLowerCase())) {
                        return { ...item, show: true }
                    } else {
                        if (item.label !== FILTER_SHOW_HIDE) {
                            return { ...item, show: false }
                        }
                        return item
                    }
                })
            }
        })
    }
    const [ riskId, setRiskId ] = useState(null)
    const orgId = localStorage.getItem('orgId')

    const handleOpenTimeline = () => {
        toggleTimelineDrawer()
        toggleModal()
    }
    const historyApiCall = () => {
        getIssueHistory(riskId, orgId)
    }
    return (
        <>
            <RiskHistoryFilterContainer ref={ref} type={'ISSUE'} />
            <Card className={cn(filteredRegulationData?.length > 0 ? 'h-[100%]' : 'h-full', 'p-4')}>
                {/* {location.pathname !==  RoutePath.MAIN_CONTAINER.MAIN + RoutePath.HISTORY.URI && <Box sx={{ borderBottom: 2 }} className='h-[8%] text-primary-foreground'>
          <TabContext sx={{ height: '100%' }} value={activeTab} key={activeTab}>
            <TabList className='normal-case h-[100%]' onChange={(event, newValue) => onTabChange(newValue)}
              sx={{ '& .MuiTabs-indicator': { background: 'hsl(var(--primary))' }, display: 'flex', alignItems: 'center', textTransform: 'none' }}>
              <Tab label="General" className='!text-h4 normal-case' value="1" sx={{ '&.Mui-selected': { color: 'hsl(var(--muted))', textTransform: 'none' }, textTransform: 'none' }} />
              <div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', marginTop: '15px', marginLeft: '-12px', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {generalCount}
              </div>
              <Tab label="Non-Compliance" className='!text-h4 normal-case' value="2" sx={{ '&.Mui-selected': { color: 'hsl(var(--muted))', textTransform: 'none' }, textTransform: 'none' }} />
              <div style={{ color: 'hsl(var(--primary))', backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', marginTop: '15px', marginLeft: '-12px', width: '20px', height: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                {nonComplianceCount}
              </div>
            </TabList>
          </TabContext>
        </Box>} */}
                {funnelDatas[funnelType]?.length > 0 && <PopoverMui id={9} anchorEl={showTypeFilter} setAnchorEl={setShowTypeFilter}>
                    <CustomSearchField className={'w-[100%] p-1'} value={funnelSearch} setSearch={setFunnelSearch} onValueChange={handleFunnelSearch} />
                    {funnelDatas[funnelType]?.filter((ele, i) => i !== funnelDatas[funnelType].length - 1).every(ele => !ele.show && ele.label) &&
                        <div className="flex justify-center h-full items-center p-4">
                            <div className="text-sm text-muted ">No Data</div>
                        </div>
                    }
                    {
                        funnelDatas[funnelType]?.map((item, i) => {
                            return (
                                <> {item?.show &&
                                    <div key={i} className={cn(i === funnelDatas[funnelType].length - 1 && 'border-t-[0.2px] border-t-[hsl(var(--primary))]', 'p-4 cursor-pointer flex items-center')} >
                                        <Checkbox
                                            checked={item.checked}
                                            onClick={(event) => handleTypeFilter(item.label)}
                                            className="mr-2"
                                            borderColor='text-primary'
                                            id={`${funnelType}-${i}`}
                                        />
                                        <label htmlFor={`${funnelType}-${i}`} className="cursor-pointer text-submenu !font-regular">{item?.label}</label>
                                        {i === funnelDatas[funnelType].length - 1 && <span className={cn(funnelDatas[funnelType].some(el => !el.checked) ? '' : 'pointer-events-none !text-grey', 'align-right text-sm ml-10 underline text-primary cursor-pointer')} onClick={() => handleTypeFilter(FILTER_RESET)}>Reset</span>}
                                    </div>
                                }</>
                            )
                        })
                    }
                </PopoverMui>}
                {dashboardView && <div
                    style={{
                        margin: '0.7rem 0 0 1rem',
                        fontSize: '14px',
                        fontWeight: 600,
                        color: 'black',
                        marginBottom: '1rem'
                    }}
                >
                    {title}
                </div>}
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', alignItems: 'center', padding: `${!dashboardView ? '1rem 1rem 0 1rem' : '0 0 0 1rem'}`, height: `${!dashboardView ? '12%' : '7%'}` }}>
                    <div className={`flex ${!dashboardView && 'w-[60%]'}`}>
                        <div className="py-2 w-[40%]">
                            <CustomSearchField value={searchValue} setSearch={setSearchValue} className={'w-[95%]'} onValueChange={handleSearchChange} />
                        </div>
                        <div className={`py-2 flex gap-2 w-[100%] overflow-auto items-center ${dashboardView && 'min-w-fit'}`} >
                            {chipData.map((chip) => {
                                if ((chip.label === 'High' || chip.label === 'Very Low') && Heatmap === '3x3') return null

                                return (
                                    <div
                                        key={chip.label}
                                        onClick={() => handleChipClick(chip.label)}
                                        style={{
                                            // width: "50%",
                                            backgroundColor: clicked[chip.label] ? `hsl(var(${chip?.color}))` : 'hsl(var(--foreground))',
                                            border: `2px solid hsl(var(${chip?.color}))`,
                                            color: clicked[chip?.label] ? 'hsl(var(--foreground))' : `hsl(var(${chip?.color}))`,
                                            cursor: 'pointer',
                                            transition: 'background-color 0.3s, border-color 0.3s, color 0.3s',
                                            borderRadius: '999px',
                                            padding: '3px 5px',
                                            height: '83%',
                                            display: 'flex',
                                            alignItems: 'center'
                                        }}
                                        className="risktable-chip"
                                    ><div className="flex items-center gap-1 justify-around text-h4">{chip.label}<span className="flex-shrink-0">{<ContentCircle className={cn('bg-card w-5 h-5')} contentClassName={cn(clicked[chip?.label] ? 'text-[hsl(var(--muted))]' : `text-[hsl(var(${chip?.color}))]`, 'font-semibold')} content={chip.count} />}</span></div></div>
                                )
                            })}
                        </div>
                    </div>
                    {dashboardView && <BellAnimation />}
                    {!dashboardView && <div className="w-[40%]">
                        <div className="flex gap-3 pl-1 items-center">

                            <div style={{ width: '100%', display: 'flex', gap: 5, alignItems: 'center', justifyContent: 'flex-end' }}>
                                {location.pathname !== '/GRC/risk/owned' && location.pathname !== RoutePath.MAIN_CONTAINER.MAIN + RoutePath.ISSUE.HISTORY && location.pathname !== RoutePath.MAIN_CONTAINER.MAIN + RoutePath.HISTORY.URI && location.pathname !== '/GRC/dispute' && location.pathname !== '/GRC/rejected-risk' && (
                                    <Tooltip title="Add Issue" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                        <Button style={{ border: '1px solid hsl(var(--border))', padding: '4px', marginLeft: '0.5rem' }} className='!min-w-0' variant="outline" onClick={handleAddRisk}>
                                            <img
                                                style={{ height: '13px', width: '13px', marginRight: '5px' }}
                                                src={'/Assets/PlusIcon.svg'}
                                                alt="ColumFilter.svg"
                                            />
                                            Add Issue
                                        </Button>
                                    </Tooltip>
                                )}
                                {/* {location.pathname !== '/GRC/history' && location.pathname !== '/GRC/dispute' && location.pathname !== '/GRC/rejected-risk' && (
                  <Tooltip title="Rejected Risk" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>

                <div onClick={() => handleRejectedRisk()} className="flex items-center justify-center text-[hsl(var(--destructive))] space-x-2 border-[1px] border-[#fff] cursor-pointer hover:border-[1px] hover:border-[#ef4444] translate-x-0.5 transition-all p-4 py-1 rounded-lg hover:bg-[#ef444420]">
                  <MdPlaylistRemove className="border-2 border-destructive rounded-[3px]" size={25} />
                </div>
                </Tooltip>
              )} */}
                                {location.pathname === RoutePath.MAIN_CONTAINER.MAIN + RoutePath.ISSUE.HISTORY && <div onClick={toggleDrawer} className="cursor-pointer  active:scale-90 transition-transform duration-150 border border-[hsl(var(--primary))] !px-2 h-full !py-1 rounded-md items-center gap-2 flex">
                                    <img
                                        src='/Common/Icon/FunnelFilter.svg'
                                        alt='Funnel Filter Icon'
                                        style={{ width: '12px', height: '12px', cursor: 'pointer' }}
                                    />
                                    <div className="text-primary text-menu">Filter</div>
                                </div>}
                                <Tooltip title="Column Setting" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                    <Button style={{ border: '1px solid hsl(var(--border))', padding: '4px', marginRight: '0.5rem' }} className='!min-w-0' variant="outline" onClick={handleColumnButtonClick}>
                                        <img
                                            style={{ height: '20px', width: '20px' }}
                                            src={'/Common/Icon/columnFilter.svg'}
                                            alt="ColumFilter.svg"
                                        />
                                    </Button>
                                </Tooltip>
                            </div>
                        </div>
                    </div>}

                </div>
                <div style={{ overflow: 'auto', height: location.pathname === RoutePath.MAIN_CONTAINER.MAIN + RoutePath.HISTORY.URI ? '70%' : '78%', width: '100%', padding: '1rem', paddingBottom: 0 }}>
                    {<GrcTableContainer className='!h-full w-full' >
                        <GrcTable>
                            <GrcTableHead>
                                <GrcTableHeadRow className='h-[40px]'>
                                    <GrcTableCell align='center' sx={{ position: 'sticky', left: '0px' }} >
                                        <Tooltip title="S.No" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                            #
                                        </Tooltip>
                                    </GrcTableCell>
                                    {selectedHeaders.map((header, index) => {
                                        if (!header.checked) return null
                                        const shouldShowSortIcon = [ 'risk', 'aging', 'description', 'status', 'createdDate', 'accountable', 'responsible', 'consulted', 'informed' ].includes(header.field)
                                        const shouldShowFunnelIcon = [ 'raisedBy', 'type', 'riskNature', 'category', 'raisedDepartment', 'impactedDepartment', 'riskOwner', 'approach' ].includes(header.field)
                                        return (
                                            <GrcTableCell

                                                className='whitespace-nowrap'

                                                sx={{
                                                    ...(header.field === 'dot' ? { position: 'sticky', right: 0, zIndex: 2, backgroundColor: 'hsl(var(--card))' } : index === 0 ? { position: 'sticky', left: '41px' } : {}),
                                                    minWidth: header.headerName === 'Age'
                                                        ? '70px'
                                                        : header.field === 'description'
                                                            ? '300px'
                                                            : [ 'approach', 'raisedBy', 'suggestedMitigation', 'raisedDepartment', 'createdDate', 'impactedDepartment', 'riskOwner', 'accountable', 'consulted', 'informed', 'responsible' ].includes(header.field) ? '200px' : [ 'type', 'riskNature', 'category' ].includes(header.field) ? '150px' : '100px'
                                                }} key={header.field}>
                                                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <span style={{ marginRight: '4px' }}>{header.headerName}</span>
                                                    {shouldShowSortIcon && (
                                                        <Tooltip title="Sort" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                            <img
                                                                src='/Common/Icon/sortIcon.svg'
                                                                alt='Sort Icon'
                                                                style={{ width: '12px', height: '12px', cursor: 'pointer', marginLeft: '4px' }}
                                                                onClick={() => sortFilter(header.field)}
                                                            />
                                                        </Tooltip>
                                                    )}
                                                    <div className="!flex-shrink-0" onClick={(e) => handleTypeClick(e, header?.field)} >
                                                        {shouldShowFunnelIcon && (
                                                            <Tooltip title="Filter" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                                                                <img
                                                                    src='/Common/Icon/FunnelFilter.svg'
                                                                    alt='Funnel Filter Icon'
                                                                    style={{ width: '12prox', height: '12px', cursor: 'pointer', marginLeft: '4px' }}
                                                                />
                                                            </Tooltip>
                                                        )}
                                                    </div>
                                                </div>
                                            </GrcTableCell>)
                                    })}
                                </GrcTableHeadRow>
                            </GrcTableHead>
                            {paginatedData?.length === 0 && <GrcTableBody className='w-full'>
                                <GrcTableRow>
                                    <GrcTableCell colSpan={12} align='center' className="!w-full !h-full text-center">{searchValue?.length > 0 ? 'No Records Found' : tabletext}</GrcTableCell>
                                </GrcTableRow>
                            </GrcTableBody>}
                            {paginatedData?.length > 0 && <GrcTableBody>
                                {paginatedData?.map((row, rowIndex) => {
                                    return (
                                        <GrcTableRow key={rowIndex} >

                                            {/* <GrcTableCell align='center' style={{ padding: '0px' , position : 'sticky', left : 0,zIndex : 4, backgroundColor: 'hsl(var(--card))' }} key={`select-${row.riskId}`}>
                      <Checkbox
                        sx={{
                          color: 'hsl(var(--primary))',
                          '&.Mui-checked': {
                            color: 'hsl(var(--primary))',
                          },
                        }}
                        checked={selectedRows?.includes(row.riskId)}
                        onChange={() => handleRowSelect(row.riskId)}
                      />
                    </GrcTableCell> */}
                                            <GrcTableCell align='center' sx={{ position: 'sticky', left: '0px', zIndex: 4 }} style={{ padding: '0px 10px 0px 10px', backgroundColor: 'hsl(var(--card))' }}>
                                                <p style={{ backgroundColor: 'hsl(var(--primary-foreground))', borderRadius: '50%', width: '30px', height: '30px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>{(rowIndex + 1)}</p>
                                            </GrcTableCell>
                                            {selectedHeaders?.map((header) => {
                                                if (!header.checked) return null
                                                return (
                                                    <GrcTableCell
                                                        align={header.field === 'title' ? 'left' : header.field === 'description' ? 'left' : 'center'}
                                                        onClick={() => { if (header.field === 'title' && !dashboardView) { handleRowClick(row) } }}
                                                        key={header.field}
                                                        sx={header.field === 'dot' ? { position: 'sticky', right: 0, zIndex: 1, backgroundColor: 'hsl(var(--card))' } : {}}
                                                        style={
                                                            header.field === 'title'
                                                                ? { position: 'sticky', left: '41px', zIndex: 1, padding: '0px 16px', backgroundColor: '#fff', cursor: `${!dashboardView && 'pointer'}` }
                                                                : {}
                                                        }
                                                    >
                                                        {header.field === 'title'
                                                            ? (
                                                                <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', borderRight: '2px solid hsl(var(--primary-foreground))', padding: '0px 30px 0px 10px' }}>
                                                                    <Typography className={`${!dashboardView && 'whitespace-nowrap'}`}>{row?.title}</Typography>
                                                                    <div className="flex flex-row text-[12px] gap-1 max-w-[130px] justify-row jus items-center ">
                                                                        <Tooltip title={`#${row?.referenceId || 0}`} arrow placement="right" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }} style={{ width: 'fit-content !important' }}>
                                                                            <Chip className="whitespace-nowrap" label={`#${row?.referenceId || 0}`} sx={{ backgroundColor: chipColorStyle(row?.issueScore), fontSize: '12px', color: '#fff', width: '100%', height: '17px', overflow: 'hidden', textOverflow: 'ellipsis', margin: '4px' }} />
                                                                        </Tooltip>
                                                                        {/* <span className="whitespace-nowrap">{formatDistToNow(row.createdDate)}</span> */}
                                                                    </div>
                                                                </div>
                                                            )
                                                            : header.field === 'impactedDepartment'
                                                                ? (
                                                                    <div >
                                                                        <Badge onMouseEnter={(event) => row?.impactedDepartment?.length > 1 && handleMouseEnter(event, row?.impactedDepartment?.filter((_, ind) => ind !== 0))} onMouseLeave={handleMouseLeave} badgeContent={`+${row?.impactedDepartment?.length - 1}`} sx={{ '& .MuiBadge-badge': { zIndex: 0, backgroundColor: 'hsl(var(--primary-foreground))', display: row?.impactedDepartment?.length === 1 && 'none', color: 'hsl(var(--primary))', fontSize: '10px', fontWeight: '500', right: '-16px' } }}>
                                                                            <Typography>{row?.impactedDepartment[0]}</Typography>
                                                                        </Badge>
                                                                    </div>
                                                                )
                                                                : header.field === 'description'
                                                                    ? (
                                                                        <div className="md:w-[400px] xl:w-[600px]">
                                                                            <p
                                                                                className="line-clamp-2 overflow-hidden text-ellipsis"
                                                                                title={row?.description}
                                                                            >
                                                                                {row?.description}
                                                                            </p>
                                                                        </div>
                                                                    )
                                                                    : header.field === 'createdDate'
                                                                        ? (
                                                                            <div className="whitespace-nowrap">{dayjs(row?.createdDate).format('D/MM/YYYY')}</div>
                                                                        )
                                                                        : header.field === 'dot'
                                                                            ? (
                                                                                <div onClick={(event) => openModal(event, row?.riskId)} style={{ cursor: 'pointer', height: '100%', width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                                                    <BsThreeDotsVertical className="ml-2" />
                                                                                </div>
                                                                            )
                                                                            : header.field === 'suggestedMitigation'
                                                                                ? (
                                                                                    <div className="w-[300px] break-all" >
                                                                                        <Badge onMouseEnter={(event) => row?.suggestedMitigation?.length > 1 && handleMouseEnter(event, row?.suggestedMitigation?.filter((_, ind) => ind !== 0))} onMouseLeave={handleMouseLeave} badgeContent={`+${row?.suggestedMitigation.length - 1}`} sx={{ '& .MuiBadge-badge': { zIndex: 0, backgroundColor: 'hsl(var(--primary-foreground))', display: row?.suggestedMitigation.length === 1 && 'none', color: 'hsl(var(--primary))', fontSize: '10px', fontWeight: '500', right: '-16px' } }}>
                                                                                            <Typography>{row?.suggestedMitigation[0]}</Typography>
                                                                                        </Badge>
                                                                                    </div>
                                                                                )
                                                                                : header.field === 'aging'
                                                                                    ? (
                                                                                        row?.status === 'Completed'
                                                                                            ? getDayBasedAgingInClosedBucket(row?.createdDate, row?.modifiedDate)
                                                                                            : getDayBasedAging(row?.createdDate)
                                                                                    )
                                                                                    : header?.field === 'periodicity'
                                                                                        ? (
                                                                                            getPeriodicity(row?.periodicity)
                                                                                        )
                                                                                        : (
                                                                                            row[header.field] || ''
                                                                                        )}
                                                    </GrcTableCell>
                                                )
                                            })}
                                        </GrcTableRow>
                                    )
                                })}
                            </GrcTableBody>}
                        </GrcTable>
                    </GrcTableContainer>}
                </div>
                {/* {filteredRegulationData.length > 0 &&
          <div style={{ display: 'flex', justifyContent: 'space-between'}} className="px-2 h-10%">
        <div style={{ alignSelf: 'center' }} className="text-muted">
          Showing data {(page - 1) * pageSize + 1} to {Math.min(page * pageSize, filteredRegulationData?.length)} of {filteredRegulationData?.length} entries
        </div> */}
                {filteredRegulationData?.length > 0 && <div style={{ display: 'flex', justifyContent: 'space-between', height: dashboardView ? '0%' : '10%', alignItems: 'center' }} className="px-[1rem]">
                    <Typography className={`text-muted ${dashboardView ? '!text-h6' : '!text-h4'} `}>
                        Showing data {entries.from} to {entries.to} of {entries.entry} entries
                    </Typography>
                    <div style={{ alignSelf: 'center' }}>
                        <Pagination
                            variant="outlined"
                            shape="rounded"
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                        />
                    </div>
                </div>}
            </Card>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                className="h-[500px] w-[300px]"
            >
                <div className="w-[200px]">
                    <div className="sticky top-0 bg-white z-10 p-2">
                        <CustomSearchField className={'h-[43px] w-full p-1'} value={searchColumnValue} setSearch={setSearchColumnValue} onValueChange={(e) => handleSearchColumnChange(e)} />
                    </div>
                    <div className="max-h-[200px] overflow-y-auto p-0">
                        {selectedHeaders
                            .filter((header) => header.headerName !== '' && header.headerName.toLowerCase().includes(searchColumnValue))
                            .map((header) => (
                                <MenuItem className="p-0" key={header.field} onClick={() => handleToggleColumn(header)} disabled={RISK_DISABLED_COLUMN_SETTINGS.includes(header.headerName)}>
                                    <div className="flex items-center gap-3 w-full">
                                        <Checkbox
                                            sx={{
                                                padding: 0,
                                                marginTop: '3px',
                                                marginBottom: '3px',
                                                marginRight: '8px',
                                                color: 'hsl(var(--primary))',
                                                '&.Mui-checked': {
                                                    color: 'hsl(var(--primary))'
                                                }
                                            }}
                                            checked={header.checked}
                                            onValueChange={() => { handleToggleColumn(header) }}
                                        />
                                        <span>{header.headerName}</span>
                                    </div>
                                </MenuItem>
                            ))}

                    </div>
                    {<div className='flex items-center gap-4 px-[16px] py-2'>
                        <Checkbox
                            checked={selectAll}
                            onCheckedChange={(event) => handleSelectAll(event)}
                            className="mr-2"
                            borderColor='text-primary'
                        />
                        <div className='flex justify-between w-full items-center'><div>{FILTER_SHOW_HIDE}</div>
                            {<span className={cn(selectedHeaders.some(el => !el.checked) ? '' : 'pointer-events-none !text-grey', 'align-right text-sm ml-10 underline text-primary cursor-pointer')} onClick={() => handleReset()}>Reset</span>}</div>
                    </div>}
                    {/* <Divider sx={{ my: 1 }} /> */}
                    {/* <div className="sticky bottom-0 bg-white z-10 flex">
          <MenuItem onClick={handleSelectAll} disabled>
            <div className="flex items-center gap-3 w-full">
            <Checkbox
              sx={{
                padding: 0,
                marginRight: '8px',
                color: 'hsl(var(--primary))',
                '&.Mui-checked': {
                  color: 'hsl(var(--primary))',
                },
              }}
              checked={selectedHeaders.every((header) => header.checked)}
              onChange={handleSelectAll}
            />
            <span>Show/Hide All</span>
            </div>
          </MenuItem>
          <MenuItem
            onClick={handleReset}
            variant="text"
            sx={{
              color: 'hsl(var(--primary))',
              fontWeight: '600',
            }}
            disabled
          >
            Reset
          </MenuItem>
        </div> */}
                </div>
            </Menu>
            <Popover
                open={Boolean(isModalOpen)}
                anchorEl={isModalOpen}
                onClose={toggleModal}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <div className='flex cursor-pointer items-center' onClick={handleOpenTimeline}><RiChatHistoryLine className='m-3' /><Typography sx={{ p: 1 }}>Timeline</Typography></div>
                <div className='flex cursor-pointer items-center'><LuUndo2 className='m-3' /><Typography sx={{ p: 1 }}>Retrieve Risk</Typography></div>

            </Popover>
            <Popper
                open={anchorPopper}
                anchorEl={anchorPopper}
                sx={{ minWidth: 300 }}
                placement="right-start"
                modifiers={[
                    {
                        name: 'offset',
                        options: {
                            offset: [ 0, 10 ]
                        }
                    }
                ]}
                transition
            >
                {({ TransitionProps }) => (
                    <Grow {...TransitionProps} timeout={350}>
                        <Box sx={{ p: 1, borderRadius: '10px', width: 300, backgroundColor: 'hsl(var(--card))', boxShadow: 'grey 0px 0px 10px 2px' }}>
                            <Typography className='whitespace-normal break-words flex flex-col overflow-hidden' style={{ fontSize: '14px', color: 'hsl(var(--muted))' }} >
                                {popperData?.map((data, index) => {
                                    return (
                                        <p className={cn(popperData?.length - 1 !== index && 'border-b-2 border-b-border', 'p-2 break-words')} key={index}>
                                            {data}
                                        </p>
                                    )
                                })}
                            </Typography>
                        </Box>
                    </Grow>
                )}
            </Popper>
            <VerticalTimelineContainer timelineType={'Issue'} data={getIssueHistoryData} apiCall={historyApiCall} ref={timelineRef} />

        </>
    )
}

export default IssueTable
